import React, { useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import russianSize from '../../../mocks/sizes/russian-size'
import Table from '../Table'
import Modal from '../Modal'
import sizes from '../../../mocks/sizes'
import GenericSelect from '../GenericSelect'
import styles from './size.module.scss'

function Size(props) {
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const openModal = () => {
    setModalIsOpen(true)
  }
  const closeModal = () => {
    setModalIsOpen(false)
  }
  const { content, current, productName, name, onChange, compact } = props

  const handleChange = (event) => {
    onChange(name, event)
  }

  const standardDesc =
    productName === 'raincoat'
      ? 'Допускаются отклонения в 5% от указанных параметров по размеру и цвету'
      : 'Допустимая норма: ±2 см'

  return (
    <div className={styles.root}>
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <React.Fragment>
          <h2 className={styles.tableTitle}>Таблица размеров</h2>
          <Table items={sizes[productName]} />
          <div className={styles.norm}>{standardDesc}</div>
        </React.Fragment>
      </Modal>
      {compact ? (
        <div className={styles.content}>
          <Label>Размеры</Label>
          {content.map(({ label, value, disabled }) => (
            <button
              className={classNames(
                styles.buttonCompact,
                current === value && styles.buttonCompactActive
              )}
              disabled={disabled}
              key={value}
              onClick={() => onChange(name, value)}
            >
              {label}
            </button>
          ))}
          <button className={styles.footerCompact} onClick={() => openModal()}>
            Открыть таблицу размеров
          </button>
        </div>
      ) : (
        <GenericSelect
          className={styles.select}
          value={current}
          onChange={handleChange}
          options={content}
          renderValue={(value) => (
            <SelectContainer>
              <div>
                Размер – {content.find((item) => item.value === value).label}
              </div>
              {russianSize[productName] && russianSize[productName][value] && (
                <div className={styles.russianSize}>
                  {russianSize[productName][value]}
                </div>
              )}
            </SelectContainer>
          )}
          renderOption={(label, value) => {
            return (
              <OptionContainer>
                <div>{label}</div>
                {russianSize[productName] &&
                  russianSize[productName][value] && (
                    <div className={styles.russianSize}>
                      {russianSize[productName][value]}
                    </div>
                  )}
              </OptionContainer>
            )
          }}
          renderFooter={() => (
            <button className={styles.tableLink} onClick={() => openModal()}>
              Открыть таблицу размеров
            </button>
          )}
        />
      )}
    </div>
  )
}

const Label = styled.div`
  font-size: 16px;
  margin-top: 24px;
  margin-bottom: 16px;
`

const SelectContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: 10px;
  font-size: 20px;
`

const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: 21px;
  height: 50px;
`

Size.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  current: PropTypes.string,
  compact: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Size
